import React from 'react';

const FoundationTestimonial = () => (
  <section className="foundationTestimonialSection">
    <blockquote className="foundationTestimonialQuote">
      Because of AZF, I bought foundational Islamic texts for the kids I teach in Madrasa. These books prepare them to read the Quran, and I chose the best ones available thanks to AZF.
    </blockquote>
    <div className="foundationTestimonialAttribution">
      — A student supported by the Foundation
    </div>
  </section>
);

export default FoundationTestimonial;
